module.exports = __webpack_public_path__ + "img/lb13.eb4e6a2f.svg";